import {
  BaseStorage,
  BaseStorageOptions,
  DataCapsule,
} from '@wix/fe-essentials/data-capsule';
import { CreateComponentSettings } from '../model';
import { DataCapsuleMergeStrategy } from './DataCapsuleMergeStrategy';
import { mapGuidComponentIdToNonGuid } from './mapGuidComponentIdToNonGuid';

export const createComponentSettings: CreateComponentSettings = ({
  createEssentials,
  environment,
}) => {
  return (options) => {
    const { dataCapsule: _dataCapsule } = createEssentials({
      dataCapsule: {
        storageStrategy: 'userPreferences',
        namespace: options.namespace,
        scope: mapGuidComponentIdToNonGuid(
          environment.componentId || environment.artifactId,
        ),
      },
    });

    const componentSettings = _dataCapsule as unknown as Omit<
      DataCapsule,
      'storageStrategy'
    > & {
      storageStrategy: BaseStorage<BaseStorageOptions>;
    };

    componentSettings.storageStrategy = new DataCapsuleMergeStrategy({
      storage: componentSettings.storageStrategy,
    });

    return _dataCapsule;
  };
};
